<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div v-if="uploadLoading" class="mask">
            <div class="lodingsIcon">
                <i class="el-icon-loading"></i><span>正在处理，请稍等。。。</span>
            </div>
        </div>
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            未入住老人列表
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row>
                    <el-button type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
                    <el-button type="success" :disabled="disabledEdit"  @click="handleEdit">编辑</el-button>
                    <el-button type="danger" :disabled="disabledDel" @click="delElderly">删除</el-button>
                    <el-button type="danger" :disabled="disabledExport" @click.native="toggleModalExport">档案导出</el-button>
                    <el-button type="danger" :disabled="disabledImport" @click="batchDialog=true">批量导入</el-button>
                    
                    <div style="float:right">
                        <el-input  placeholder="请输入老人姓名" v-model="name" clearable @change="getList" style="margin:0 10px;width:200px"></el-input>
                        <el-input  placeholder="请输入身份证号" v-model="idCard" clearable @change="getList" style="margin-right:10px;width:200px"></el-input>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>
                <div style="clear: both;"></div>
                <el-dialog title="批量添加" @close='closeBatchDialog'  :visible.sync="batchDialog" class="dialog" width='450px' center top='30vh' :close-on-click-modal='false'>
                    <el-upload
                        class="upload-demo"
                        ref="upload"
                        :action="uploadUrl"
                        :data='uploadData'
                        :on-success="uploadSuccess"
                        :on-exceed="handleExceed"
                        :before-upload='beforeUpload'
                        style="text-align: center;"
                        :auto-upload="false"
                        :limit='1'>
                        <el-button slot="trigger" type="primary">选取文件</el-button>
                        <el-button  style="margin-left: 25px;" type="success" @click="getTemplate">下载模板</el-button>
                    </el-upload>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="batchDialog=false">取 消</el-button>
                        <el-button type="primary"  @click="submitUpload">提交</el-button>
                    </div>
                </el-dialog>
                <el-dialog title="错误信息" :visible.sync="outerVisible" top="30vh" width="800px">
                    <el-table :data="gridData">
                        <el-table-column property="index" label="行数"></el-table-column>
                        <el-table-column property="name" label="姓名"></el-table-column>
                        <el-table-column property="message" label="错误信息"></el-table-column>
                    </el-table>
                </el-dialog>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>
                    
                    <el-table :data="tableData" v-loading="loading" highlight-current-row :height="th" border style="width: 100%;" @row-click='rowClick'>
                        <el-table-column label="老人姓名" prop="name" width="100"></el-table-column>
                        <el-table-column label="手机号" prop="phone" width="120"></el-table-column>
                        <el-table-column label="身份证号" prop="idCard" width="180"></el-table-column>
                        <el-table-column label="年龄" prop="age" width="60"></el-table-column>
                        <el-table-column label="性别" prop="gender" width="60">
                            <template slot-scope="scope">
                                <span v-if="scope.row.gender==0">女</span>
                                <span v-if="scope.row.gender==1">男</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="balance"  width="100" label="余额(元)"></el-table-column>
                        <el-table-column prop="deposit"  width="100" label="预交金(元)"></el-table-column>
                        <el-table-column prop="imprest"  width="100" label="备用金(元)"></el-table-column>
                        <el-table-column label="地址" prop="areaName" ></el-table-column>
                        <el-table-column label="详细住址" prop="address" ></el-table-column>
                        <el-table-column label="入住状态"  >未入住</el-table-column>
                        
                        <el-table-column fixed="right" label="操作" width="200">
                            <template slot-scope="scope">
                                
                                <el-button type="success" size="small" @click="handleInfo(scope.row)">详情</el-button>
                            </template>
                        </el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-bind:areaValue="areaValue" v-bind:nationValue="nationValue" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-bind:areaValue="areaValue" v-bind:nationValue="nationValue" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>
        <Info ref="myInfo" v-show="showModalInfo" v-bind:areaValue="areaValue" v-bind:nationValue="nationValue" v-on:closeInfo="showModalInfo=false" v-on:getList="getList"></Info>
        <Export ref="myExport" v-show="showModalExport" v-on:closeExport="showModalExport=false" v-on:getList="getList"></Export>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Edit from "./Edit";
    import Add from "./Add";
    import Info from "./Info";
    import Export from "./Export";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:true,
                uploadLoading:false,
                uploadUrl:this.$institutionUrl+'ImportExcel/ImportExcel',
                uploadData:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
                },
                gridData:[],
                batchFileList:[],
                outerVisible:false,
                batchDialog:false,
                disabledAdd:true,
                menuButtonList:null,
                showModalAdd:false,
                showModalEdit:false,
                showModalHistoricalFiles:false,
                showModalExport:false,
                showModalLeave:false,
                disabledExport:true,
                disabledLeave:true,
                disabledEdit:true,
                disabledDel:true,
                disabledImport:true,
                showModalInfo:false,
                name:'',
                idCard:'',
                areaValue:[],
                nationValue:[],
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                status:-1,
                statusValue:[{name:'全部状态',value:-1},{name:'正常',value:0},{name:'禁用',value:1}],
                row:null

            }
        },
        components:{
            Add,Edit,Info,Export
        },
        created(){
            this.init();
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
            handleExceed() {
                this.$message.error(`只能上传1个文件，如果需要更改请去除当前文件`);
            },
            uploadSuccess(response){
                this.uploadLoading=false
                if(response.error === 0){
                    this.batchDialog=false
                     if(response.data.length>0){
                         this.gridData = response.data
                         this.outerVisible = true;
                     }else{
                         this.getList();
                     }
                     
                }else if(response.error === 1){
                    this.$message({type: 'info', message: response.data.message});
                }
            },
            
            removeFile(){
                this.addForm.url="";
            },
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                console.log(menu)
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="添加"){
                            this.disabledAdd = false;
                        }
                        if(menu[i].buttonName=="批量导入"){
                            this.disabledImport = false;
                        }
                    }
                }
            },
            toggleModalExport:function(){
                this.showModalExport = !this.showModalExport;
                this.$refs.myExport.init(this.row);
            },
            delElderly(){
                this.$confirm('确认删除 '+this.row.name +' , 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        this.delSubmit();
                        
                    
                    }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });          
                });
            },
            submitUpload() {
                this.$refs.upload.submit();
            },
            beforeUpload(file){
                let Xls = file.name.split('.'); 
                if(Xls[1] === 'xls'||Xls[1] === 'xlsx'){
                    this.uploadLoading = true
                    this.batchDialog=false
                    return file
                }else {
                    this.$message.error('上传文件只能是 xls/xlsx 格式!')
                    return false
                }
            },
            delSubmit(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Elderly/DelElderly",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        elderlyCode:this.row.elderlyCode
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$message("删除成功");
                            this.getList();
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            init(){
               this.areaValue = JSON.parse(window.localStorage.getItem('areaValue'));
                // this.$axios({
                //     method: 'post',
                //     url: this.$institutionUrl+"Area/ListAll",
                //     data: {
                //         timeStr: timeStr,
                //         sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                //         staffCode: getStaffCode(),
                //     }
                // }).then(
                //     (response) => {
                //         if (response.data.error == 0) {
                //             var data=JSON.stringify(response.data.data);
                //             data=JSON.parse(data.replace(/"listAreaDTO":\[\],/g,''))
                //             this.areaValue = data
                //         }else if(response.data.error == 1){
                //             this.$message({type: 'info', message: response.data.message});
                //         }
                //     }
                // )
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"SysNation/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.nationValue = response.data.data;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
               
            },
            rowClick(val) {
                this.row = val;
                   this.disabledExport =false;
                console.log(this.menuButtonList)
                if(this.menuButtonList.indexOf("编辑")!=-1){
                    this.disabledEdit =false;
                }
                // if(this.menuButtonList.indexOf("档案导出")!=-1){
                 
                // }
                if(this.menuButtonList.indexOf("删除")!=-1){
                    this.disabledDel =false;
                }
            },
            handleEdit() {
                this.$refs.myEdit.init(this.row);
                this.showModalEdit = !this.showModalEdit;
            },
            handleInfo(row) {
                this.$refs.myInfo.init(row);
                this.showModalInfo = !this.showModalInfo;
            },
            toggleHistory(){
                this.$refs.myHistoricalFiles.init();
                this.showModalHistoricalFiles = !this.showModalHistoricalFiles;
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            closeLeave:function(){
                this.showModalLeave = !this.showModalLeave;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            getTemplate() {
                var that = this
                this.$axios.get(this.$institutionUrl + 'ElderlyFile/GetElderlyTemplate', {
                    responseType: 'blob',
                    params: {
                    timeStr: timeStr,
                    sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                    staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        let fileName = '老人表模板.xlsx';
                        that.file(response, fileName);
                    }
                )
            },
            file(response, fileName) {
                let blob = new Blob([response.data]);
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob, fileName);
                } else {
                    let elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    document.body.removeChild(elink);
                }
            },
            //批量导入
            toggleModalImport:function(){
                
            },
            toggleModalLeave:function(){
                this.showModalLeave = !this.showModalLeave;
                this.$refs.myLeave.init(this.row);
            },
            closeExport:function(){
                this.showModalExport = !this.showModalExport;
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },
            getList(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Elderly/GetListByNotCheckinStatus",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        name:this.name,
                        idCard:this.idCard,
                        status:this.status,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    this.disabledEdit=true;
                    this.disabledDel=true;
                    this.disabledExport=true;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },



        }
    }
</script>

<style lang="scss" scoped>

    /deep/ .el-table__body tr.current-row>td  {
        background-color: #409EFF;
        color:#fff;
    }
    /deep/ .el-loading-mask .el-icon-loading{
        color: #fff;
    }
    /deep/ .el-loading-mask .el-loading-text{
        color: #fff;
    }
    .mask {
        background-color: rgb(0, 0, 0);
        opacity: 0.3;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 199;
        .lodingsIcon{
            /* margin-top: 47vh; */
            margin: 47vh auto;
            height: 6vh;
            width: 300px;
            font-size: 16px;
            color: white;
            i{
                z-index: 200;
                font-size: 16px;
                margin-right:10px ;
                
            }
        }
      }
     
</style>
